import React from "react";
import "./bufferAnimation.css"; // Include CSS for styling

const BufferAnimation = () => {
  return (
    <div className="buffer-animation">
      <div className="spinner"></div>
    </div>
  );
};

export default BufferAnimation;
